exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".scrollable[_v-bcc4867a]{overflow-y:scroll;max-height:85%;margin-top:50px;margin-bottom:50px}.modal-content[_v-bcc4867a]{border:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-bcc4867a&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Modals/Modal-terms-conditions.vue
// module id = 454
// module chunks = 0